export const saveCartToStorage = (cartItems) => {
  localStorage.setItem("cart", JSON.stringify(cartItems));
  window.dispatchEvent(new Event("cartUpdated"));
};
